import { render } from "./TheIntroduction.vue?vue&type=template&id=bcc752ea&scoped=true"
import script from "./TheIntroduction.vue?vue&type=script&lang=js"
export * from "./TheIntroduction.vue?vue&type=script&lang=js"

import "./TheIntroduction.vue?vue&type=style&index=0&id=bcc752ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc752ea"]])

export default __exports__